import React, { Component } from 'react';
import { Title } from '../Components';
import { OptionQuantity } from './Options';
// import Fade from 'react-reveal/Fade';

class StepQuantity extends Component {
	constructor() {
		super();
	}

	render() {
		const { options, handleSelection } = this.props
		console.log('options', options)
		return (
			<div>
				{/* <Fade big delay={400}> */}
					<Title title="How many pairs per month?" />
				{/* </Fade> */}
				{/* <Fade big delay={500}> */}
					{options &&
						<div className="BoxBuilder_Options BoxBuilder_Options--Quantity">
							{options.map((option, index) => <OptionQuantity
								{...option}
								key={`quantity-option-${index}`}
								handleSelection={() => handleSelection(option)}
							/>)}
						</div>
					}
				{/* </Fade> */}
			</div>
		)
	}
}

export default StepQuantity;